import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

// 工会主播激励计划 http://wiki.xunlei.cn/pages/viewpage.action?pageId=132042881
export const getUnionRecruitHomepage = createAsyncThunk(
  '/live/activity/union_recruit_homepage',
  async (arg, store: any) => {
    const resp = await http.post('/live/activity/union_recruit_homepage', {
      ...store.getState().env.deviceinfo,
    })
    return {
      ...resp.data.data,
    }
  }
)

interface InitialStateType {
  task_list?: {
    anchor_need: number
    anchor_target: number
    income_need: number
    income_target: number
    reward_tag: string
    show_status: boolean
    status: number
    task_id: number
  }[]
  member?: {
    avatar?: string
    id?: number
    name?: string
  }
  anchor_list?: []
  count_down?: number
  reward_tags?: []
  anchor_num?: number
  income_num?: number
  union_id?: number
  is_union_leader?: boolean
}

const initialState: InitialStateType = {}

export const NewUnionAnchorSlice = createSlice({
  name: 'NewUnionAnchor',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getUnionRecruitHomepage.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
  },
})
export default NewUnionAnchorSlice.reducer
export const NewUnionAnchorActions = NewUnionAnchorSlice.actions
